import HeaderTwo from './component.styles'
export default HeaderTwo
